import {Alert, Slide, Snackbar} from "@mui/material";
import React, {useState} from "react";

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

const CustomisedSnackbar = ({
  message = "Customised snackbar",
  severity = "success",
  open,
  handleClose,
  anchorOrigin = {vertical: "bottom", horizontal: "center"},
  autoHideDuration = 3000,
  sx = {},
}) => {
  const defaultSx = {
    '& .MuiSnackbar-root': {
      zIndex: 9999,
    },
    '& .MuiAlert-root': {
      backgroundColor: severity === 'success' ? '#4caf50' : 
                      severity === 'error' ? '#f44336' : 
                      severity === 'warning' ? '#ff9800' : '#2196f3',
      color: 'white',
      fontWeight: 600,
      fontSize: '0.95rem',
      boxShadow: `0 8px 32px rgba(${
        severity === 'success' ? '76, 175, 80' : 
        severity === 'error' ? '244, 67, 54' : 
        severity === 'warning' ? '255, 152, 0' : '33, 150, 243'
      }, 0.4)`,
      border: `2px solid ${
        severity === 'success' ? '#388e3c' : 
        severity === 'error' ? '#d32f2f' : 
        severity === 'warning' ? '#f57c00' : '#1976d2'
      }`,
      borderRadius: '12px',
      minWidth: '300px',
      transform: 'scale(1.02)',
      '& .MuiAlert-icon': {
        color: 'white',
        fontSize: '1.5rem',
      },
      '& .MuiAlert-message': {
        fontWeight: 600,
      },
    },
    ...sx,
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={anchorOrigin}
        autoHideDuration={autoHideDuration}
        open={open}
        onClose={handleClose}
        TransitionComponent={TransitionUp}
        sx={defaultSx}
      >
        <Alert
          icon={false}
          onClose={handleClose}
          severity={severity}
          sx={{width: "100%"}}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CustomisedSnackbar;
